import {
	GETKYCREPORTLIST_SUCCESS,
	GETKYCREPORTLIST_FAILED,
	RESET_GETKYCREPORTLIST,
	LOADING_GETKYCREPORTLIST,
	NETWORK_ERROR_GETKYCREPORTLIST
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetKycReportList = () => {
	return { type: RESET_GETKYCREPORTLIST };
};

const getKycReportList = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_GETKYCREPORTLIST });
	await partnerServices
		.post("kycReportList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(getKycReportListsuccess(res.data));
					break;
				default:
					dispatch(getKycReportListFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_GETKYCREPORTLIST,
				payload: err
			});
		});
};
function getKycReportListsuccess(data) {
	return {
		type: GETKYCREPORTLIST_SUCCESS,
		payload: data
	};
}
function getKycReportListFailed(data) {
	return {
		type: GETKYCREPORTLIST_FAILED,
		payload: data
	};
}

export { resetGetKycReportList, getKycReportList };
